import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ModalService } from '../../services/modal.service';

import { CampaignYearPipe } from '../../pipes/campaignYear.pipe';
import { Campaign } from '../../models/campaign.model';
import { CampaignService } from '../../services/campaign.service';
import { correctDate, showErrorMessage } from '../../utils/utils';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  standalone: true,
  selector: 'campaign-edit',
  templateUrl: 'campaign-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CampaignYearPipe, TranslatePipe, CommonModule, FormsModule, BsDatepickerModule],
  providers: [CampaignService],
})
export class CampaignEditComponent implements OnInit, OnDestroy {
  @Input() campaign: Campaign;
  @Output() close = new EventEmitter();
  error: any;
  sub: any;

  edited = false;

  campaignId: number;
  isStartingOnCollapsed: boolean = false;
  isEndingOnCollapsed: boolean = false;

  constructor(
    private campaignService: CampaignService,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  goBack(savedcampaign: Campaign = null) {
    this.close.emit(savedcampaign);
    this.router.navigate(['/campaigns']);
    return false;
  }

  save() {
    if (this.campaign.startingOn) {
      this.campaign.startingOn = correctDate(<Date>this.campaign.startingOn);
    }

    if (this.campaign.endingOn) {
      this.campaign.endingOn = correctDate(<Date>this.campaign.endingOn);
    }

    this.campaignService.save(this.campaign).subscribe(
      (campaign) => {
        this.campaign = campaign;
        this.goBack(campaign);
      },
      (error) => this.handleSaveError(error),
    );
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      if (this.route.snapshot.url[1].path === 'new') {
        this.edited = false;
        this.campaign = new Campaign();
        this.isStartingOnCollapsed = true;
        this.isEndingOnCollapsed = true;
      } else if (this.route.snapshot.url[1].path === 'edit') {
        this.campaignId = +params['campaignId'];
        this.edited = true;
        // FIXME traiter les erreurs ; afficher un message
        this.campaignService.getCampaign(this.campaignId).subscribe(
          (campaign) => (this.campaign = campaign),
          (e) => this.handleGetError(e),
        );
      }
    });
  }

  handleSaveError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette campagne");
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, 'Il y a des erreurs dans le formulaire');
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à consulter cette campagne").then((r) => {
        this.router.navigate(['/campaigns']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, 'Une erreur est survenue').then((r) => {
        this.router.navigate(['/campaigns']);
      });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
